import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';

import {
  FontAwesomeModule,
  FaIconLibrary
} from '@fortawesome/angular-fontawesome';
import {
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faEye,
  faTimes,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
  faFilter,
  faTasks,
  faCheck,
  faSquare,
  faLanguage,
  faPaintBrush,
  faLightbulb,
  faWindowMaximize,
  faStream,
  faBook,
  faInfo,
  faInfoCircle,
  faCrosshairs
} from '@fortawesome/free-solid-svg-icons';
import { faMediumM, faGithub } from '@fortawesome/free-brands-svg-icons';

import { BigInputComponent } from './big-input/big-input/big-input.component';
import { BigInputActionComponent } from './big-input/big-input-action/big-input-action.component';
import { RtlSupportDirective } from './rtl-support/rtl-support.directive';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { RegistroPersonasEmpresasLibModule } from '@rpe/registro-personas-empresas-lib';
import { UbicacionesModule } from '../features/ubicaciones/ubicaciones.module';
import { BaseTableComponent } from './base-table/base-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PageTemplateComponent } from './page-template/page-template.component';
import { UiButtonComponent } from './ui-button/ui-button.component';
import { CustomToolTipComponent } from './custom-tool-tip/custom-tool-tip.component';
import { MatIconTooltipComponent } from './mat-icon-tooltip/mat-icon-tooltip.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    TranslateModule,

    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatCardModule,
    MatCheckboxModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatGridListModule,
    MatPaginatorModule,
    MatStepperModule,
    MatRadioModule,
    MatTableModule,
    MatSortModule,
    FontAwesomeModule,
    NgSelectModule,
    OverlayModule,

    // APP
    RegistroPersonasEmpresasLibModule
  ],
  providers: [
    // TODO - Change for internasionalization
    { provide: MAT_DATE_LOCALE, useValue: 'es-UY' }
  ],
  declarations: [
    BigInputComponent,
    BigInputActionComponent,
    RtlSupportDirective,
    ConfirmDialogComponent,
    BaseTableComponent,
    PageTemplateComponent,
    UiButtonComponent,
    CustomToolTipComponent,
    MatIconTooltipComponent,
    FileUploaderComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TranslateModule,
    BaseTableComponent,
    MatButtonModule,
    MatMenuModule,
    MatTabsModule,
    MatChipsModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatCardModule,
    MatListModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatSliderModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatGridListModule,
    MatStepperModule,
    MatRadioModule,
    FileUploaderComponent,
    FontAwesomeModule,
    BigInputComponent,
    BigInputActionComponent,
    RtlSupportDirective,
    ConfirmDialogComponent,
    NgSelectModule,
    PageTemplateComponent,
    UiButtonComponent,
    CustomToolTipComponent,
    MatIconTooltipComponent
  ]
})
export class SharedModule {
  constructor(faIconLibrary: FaIconLibrary) {
    faIconLibrary.addIcons(
      faGithub,
      faMediumM,
      faPlus,
      faEye,
      faEdit,
      faTrash,
      faMinus,
      faTimes,
      faCaretUp,
      faCaretDown,
      faExclamationTriangle,
      faFilter,
      faTasks,
      faCheck,
      faSquare,
      faLanguage,
      faPaintBrush,
      faLightbulb,
      faWindowMaximize,
      faStream,
      faBook,
      faInfo,
      faInfoCircle,
      faCrosshairs
    );
  }
}
